import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getVehicleTypesRequest } from "lib/api/reference/vehicleType";
import type { VehicleTypeInterface } from "types/reference";

export const vehicleTypeReferenceKeys = {
    all: ["reference", "vehicle-type"] as const,
    list: (languageCode: string) => [...vehicleTypeReferenceKeys.all, "list", languageCode] as const,
};

export const fetchVehicleTypes = (languageCode: string) =>
    parseResponse<Array<VehicleTypeInterface>>(getVehicleTypesRequest(languageCode));

export const vehicleTypeReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<VehicleTypeInterface>>({
        queryKey: vehicleTypeReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchVehicleTypes(languageCode),
        enabled: Boolean(languageCode),
    });

export const useVehicleTypes = (languageCode: string) => useQuery(vehicleTypeReferenceQueryOptions(languageCode));
